// extracted by mini-css-extract-plugin
module.exports = {"dj-case":"case_dj-case__kSeC4","dj-case-center":"case_dj-case-center__2I4Gu","dj-case-whole":"case_dj-case-whole__bhPfi"};